module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-unocked-089b275b9e776f09f6e46e670f97a091.svg";